import React from "react";
import { Link } from "react-router-dom";
import { AccountOnReviewIcon } from "../../../assets/icons";
import { useTranslation } from "../../../i18n/LanguageContext";
import SignupLayout from "../../auth/components/SignupLayout";

const AccountOnReview = () => {
   const { t } = useTranslation();

   return (
      <SignupLayout showcase="expert" backTo="/auth/login">
         <div className="kap-org-verify">
            <img
               src={AccountOnReviewIcon}
               alt={t("account-on-review-icon-alt")}
               style={{ width: "72px", height: "72px", marginBottom: "20px" }}
            />
            <h1 className="kap-org-signup__title kap-org-verify__title">
               {t("got-your-application-title")}
            </h1>
            <p className="kap-org-verify__text">{t("application-review-description-text")}</p>
            <p className="kap-org-verify__text">
               {t("in-the-meantime-prefix-text")}{" "}
               <a href="https://kaporg.com/">www.kaporg.com</a>{" "}
               {t("in-the-meantime-suffix-text")}
            </p>
            <p className="kap-org-verify__text">{t("thank-you-for-interest-text")}</p>

            <Link to="/auth/login" className="btn sign-btn font-weight-bold kap-org-verify__submit">
               {t("got-it-button")}
            </Link>

            <p className="kap-org-verify__help">
               {t("didnt-get-email-text")}{" "}
               <a href="mailto:info@kaptechgroup.com">info@kaptechgroup.com</a>
            </p>
         </div>
      </SignupLayout>
   );
};

export default AccountOnReview;
